export default {
  assistance: {
    name: 'Assistance',
    question: 'Vous avez des questions ? ',
    centreOuvert:
      'Nous sommes à votre disposition au 01 42 22 54 90 du lundi au vendredi de 7h30 à 18H',
    envoyerMail: 'Envoyer un email',
    gestionnaire: 'Votre Gestionnaire',
    itineraire: 'Itinéraire',
    telephone: 'Tél',
    gestionRDV: {
      libelle: 'Gérer vos rendez-vous',
      email: 'bilan@leciem.org',
    },
    relationClient: {
      libelle: 'Votre relation Client',
      email: 'relationclient@leciem.org',
    },
    suiviMedical: {
      libelle: 'Votre suivi médical',
      email: 'suivimedical@leciem.org',
      telephone: '',
    },
    qualite: {
      libelle:
        'Faire une réclamation ou nous faire part de vos remarques sur le déroulement du bilan',
      email: '',
      telephone: '',
    },
  },
}
